import ProductGrid from 'shared/components/ProductGrid/ProductGrid'
import useCurrency from 'shared/hooks/useCurrency'
import { useGridContext } from './SearchGridContext'

interface ConsumerSearchHit {
  id: string
  name: string
  url: string
  slug: string
  pictureUrl: string
  retailPrice?: {
    localizedValue: string | null
  }
  price?: {
    localizedValue: string | null
  }
  brandName: string
}

const consumerSearchMapHitsToProducts = (hits: ConsumerSearchHit[]) => {
  return hits.map((hit) => {
    const { id, name, slug, pictureUrl, brandName, retailPrice, price } = hit
    return {
      id,
      name,
      slug,
      pictureUrl,
      retailPrice: {
        localizedValue: retailPrice?.localizedValue * 100,
      },
      price: {
        localizedValue: price?.localizedValue * 100,
      },
      brandName,
    }
  })
}

interface ConsumerSearchGridProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  hits: any[]
  sizeFilterCount?: number
}

export const ConsumerSearchGrid: React.FunctionComponent<ConsumerSearchGridProps> = ({
  hits,
  sizeFilterCount,
}) => {
  const { loading, error } = useCurrency()

  const { hasNewProductOnly } = useGridContext()

  if (loading || error) {
    return null
  }

  return (
    <ProductGrid
      products={consumerSearchMapHitsToProducts(hits)}
      maxColumns={3}
      hideAdditionalPrices={hasNewProductOnly || sizeFilterCount === 1}
    />
  )
}
